// colors
export const colorHackRed = "#f2463a"
export const colorHackRedMed = "#f56f65"
export const colorHackRedLight = "#f89790"
export const colorPurple = "#5C63AB"
export const colorPurpleLight = "#5C63AB19"
export const colorPurplePale = "#D1D5FF"
export const colorHackYellow = "#ffd081"
export const colorHackTeal = "#48DEE2"
export const purple = "#5C63AB"
export const purpleLight = "#5C63AB19"
export const blue = "#0069FF"
export const hackBlack = "#202020"
export const hackBlack80 = "#4d4d4d"
export const hackBlack70 = "#636363"
export const hackBlack60 = "#797979"
export const hackBlack40 = "#a6a6a6"
export const hackBlack30 = "#bcbcbc"
export const hackBlack20 = "#d2d2d2"
export const hackBlack10 = "#e9e9e9"
export const hackBlack5 = "#f4f4f4"
export const hackWhite = "#fff"

// global colors
export const globalColorText = hackBlack70
export const globalColorBg = hackWhite
export const globalColorPrimary = colorHackRed

// screen breakpoint sizes
export const smUp = "768px"
export const mdUp = "992px"
export const lgUp = "1200px"
